import FormElement from './form-element.js';

class SwitchToggles extends FormElement {
	#container;
	#elements = {};

	constructor(container) {
		super();

		if (container instanceof jQuery) {
			container = container[0];
		}

		this.#container = container;

		this.#init();
	}

	#init() {
		const switches = Array.from(this.#container.querySelectorAll('.switch-toggle'));

		for (const el of switches) {
			const name = el.dataset.name;

			super.store(name, +el.dataset.toggled);

			el.addEventListener('click', e => {
				e.preventDefault();

				this.set(name);
			});

			this.#elements[ name ] = el;
		}
	}

	set(name, toggle, ... args) {
		return this.#handleUpdate(name, toggle, true, ... args);
	}

	update(name, toggle) {
		return this.#handleUpdate(name, toggle, false);
	}

	reset(name = null) {
		if (!name) {
			for (const key of Object.keys(this.#elements)) {
				this.reset(key);
			}
			return;
		}

		return this.update(name, 0);
	}

	#handleUpdate(name, toggle = null, callback = true, ... args) {
		const value = toggle === null ? (1 - this.get(name)) : +!!+toggle;
		const el = this.#elements[ name ];

		const changed = value !== this.get(name);

		super.store(name, value);

		el.dataset.toggled = value;
		el.classList.toggle('switch-toggle-toggled', !!value);
		el.querySelector('input').value = value;

		super.runCallback(name, 'update', ... args);

		if (callback) {
			super.runCallback(name, 'set', ... args);
		}

		return changed;
	}
}

function init(container) {
	return new SwitchToggles(container);
}

export default { init };
